import { jsx, jsxs } from "react/jsx-runtime";
import { Label, Separator, Switch, XStack, YStack } from "tamagui";
function SwitchDemo() {
  return /* @__PURE__ */ jsxs(YStack, { width: 200, alignItems: "center", space: "$3", children: [
    /* @__PURE__ */ jsx(SwitchWithLabel, { size: "$2" }),
    /* @__PURE__ */ jsx(SwitchWithLabel, { size: "$3" }),
    /* @__PURE__ */ jsx(SwitchWithLabel, { size: "$4" }),
    /* @__PURE__ */ jsx(SwitchWithLabel, { size: "$5" })
  ] });
}
function SwitchWithLabel(props) {
  const id = `switch-${props.size.toString().slice(1)}`;
  return /* @__PURE__ */ jsxs(XStack, { width: 200, alignItems: "center", space: "$4", children: [
    /* @__PURE__ */ jsx(
      Label,
      {
        paddingRight: "$0",
        minWidth: 90,
        justifyContent: "flex-end",
        size: props.size,
        htmlFor: id,
        children: "Dark mode"
      }
    ),
    /* @__PURE__ */ jsx(Separator, { minHeight: 20, vertical: true }),
    /* @__PURE__ */ jsx(Switch, { id, size: props.size, children: /* @__PURE__ */ jsx(Switch.Thumb, { animation: "quick" }) })
  ] });
}
export {
  SwitchDemo,
  SwitchWithLabel
};
//# sourceMappingURL=SwitchDemo.js.map
